import { EmailAndPasswordInterface } from '@/entities/app/auth/auth'
import axios from 'axios'
import { API_KEY, API_URL, CUSTOMERS_KEY } from '../keys'

export const authWithEmailAndPassword = async (
	body: EmailAndPasswordInterface
) => {
	const response = await axios.post(`${API_URL}/auth/users/login/local`, body, {
		headers: {
			'sce-api-key': CUSTOMERS_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const verifyUserWithCode = async (code: number) => {
	const response = await axios.post(
		`${API_URL}/auth/users/login/verify`,
		{
			code,
		},
		{
			headers: {
				'sce-api-key': CUSTOMERS_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)
	if (response) return response
}

export const verifyToken = async (token: string) => {
	const response = await axios.post(
		`${API_URL}/auth/users/token/verify`,
		{
			token,
		},
		{
			headers: {
				'sce-api-key': CUSTOMERS_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)

	if (response) return response
}

export const changePassword = async (
	code: number,
	email: string,
	passwordCurrent: string,
	passwordNew: string
) => {
	const response = await axios.patch(
		`${API_URL}/auth/users/session/change/password/${code}`,
		{
			email,
			passwordCurrent,
			passwordNew,
		},
		{
			headers: {
				'sce-api-users-key-validation': API_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)

	if (response) return response
}

export const sendVerifyCode = async (email: string) => {
	const response = await axios.get(
		`${API_URL}/auth/users/session/code/send/${email}`,
		{
			headers: {
				'sce-api-key': CUSTOMERS_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)

	if (response) return response
}
